import { atom } from 'recoil';
import { TRoomsParams } from 'common/types/floor-params.type';

export const roomsAtom = atom({
  key: 'rooms',
  default: [] as TRoomsParams[],
});

export const defaultRoomParams = {
  createdDate: '',
  calculatorId: '',
} as TRoomsParams;

export const roomArea = atom({
  key: 'roomArea',
  default: false,
});

export const calculatedRoomsParams = atom({
  key: 'calculatedRoomParams',
  default: defaultRoomParams,
});

export const activeRoomId = atom({
  key: 'selectedRoomId',
  default: '',
});
